// extracted by mini-css-extract-plugin
module.exports = {"modal":"IconModal_modal__gK8ju"};